import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { QUERY_KEY as SERVICES_QUERY_KEY } from '../../CategoryCard/queries/useGetServicesByCategory.query';
import { QUERY_KEY as CATEGORIES_QUERY_KEY } from '../../../queries/useGetCategories.query';
import { CategoryTypeDto, ServiceTypeValues } from '../../../Services.types';
import { CreateServiceFormValues } from '../ServiceModal.types';

const useCreateServiceQuery = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    (payload: CreateServiceFormValues) =>
      api.post(API_URL.SERVICES, {
        name: payload.name,
        category_type: payload.categoryType as CategoryTypeDto,
        service_type: ServiceTypeValues.MANUAL_CLAIM,
      }),
    {
      onSuccess: (_data, payload) => {
        queryClient.invalidateQueries({ queryKey: [CATEGORIES_QUERY_KEY] });
        queryClient.invalidateQueries({ queryKey: [SERVICES_QUERY_KEY, payload.categoryType] });
      },
    }
  );

  const handleCreate = useCallback(
    async (payload: CreateServiceFormValues) => {
      await mutateAsync(payload);
    },
    [mutateAsync]
  );

  return { handleCreate, isLoading };
};

export default useCreateServiceQuery;
